<!--
 @description 重要操作记录
 @author xiehan
 @date 2020/02/19
-->
<template>
  <div class="importantOperation__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto">
      <el-form-item :label="$t('logComponentManage.site')">
        <g-select :list="siteList" v-model="searchForm.siteCode"></g-select>
      </el-form-item>
      <el-form-item :label="$t('importantOperation.group')">
        <g-select :list="select_record" v-model="searchForm.group" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('importantOperation.appName')">
        <g-select :list="select_appName" v-model="searchForm.appName" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('importantOperation.level')">
        <g-select :list="select_risk" v-model="searchForm.level" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('importantOperation.opTime')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="date">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="date">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item input-width="auto">
        <el-button type="primary" 
          v-g-rac="gRac('importantOperation@search')"
          @click="search"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary" 
          v-g-rac="gRac('importantOperation@add')"
          @click="addOperation"
          v-text="$t('common.add')"></el-button>
        <el-button type="primary" 
          v-g-rac="gRac('importantOperation@delete')"
          @click="deleteOperation"
          v-text="$t('importantOperation.batchDelete')"></el-button>
        <el-button type="primary" 
          v-g-rac="gRac('importantOperation@export')"
          @click="e_export"
          v-text="$t('accidentEntry.export')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange"
      :selection="true"
      :selectionChange="multiSelect"
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="operationDiaTitle"
      :visible.sync="operationDiaVis"
      width="400px">
      <el-form ref="handleForm" :model="handleForm" input-width="180px" label-width="80px" :rules="rules">
        <el-form-item :label="$t('importantOperation.group')" prop="group">
          <g-select v-model="handleForm.group" :list="select_record"></g-select>
        </el-form-item>
        <el-form-item :label="$t('importantOperation.appName')" prop="appName">
          <g-select v-model="handleForm.appName" :list="select_appName"></g-select>
        </el-form-item>
        <el-form-item :label="$t('importantOperation.opTime')" prop="opTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="handleForm.opTime" type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('importantOperation.duration')" prop="duration">
          <el-input v-model="handleForm.duration"></el-input>
        </el-form-item>
        <el-form-item :label="$t('importantOperation.level')" prop="level">
          <g-select v-model="handleForm.level" :list="select_risk"></g-select>
        </el-form-item>
        <el-form-item :label="$t('importantOperation.incidence')" prop="incidence">
          <el-input v-model="handleForm.incidence"></el-input>
        </el-form-item>
        <el-form-item :label="$t('importantOperation.operator')" prop="operator">
          <el-input v-model="handleForm.operator"></el-input>
        </el-form-item>
        <el-form-item :label="$t('importantOperation.remarks')" prop="remarks">
          <el-input v-model="handleForm.remarks"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="operationDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" @click="operationDiaConfirm" v-text="$t('common.submit')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import exportTips from '@/components/mixins/exportTips'
  import rac from '@/plugins/rac-mixin.js'
  import importantOperationBiz from '@/logic/continuousDelivery/importantOperationBiz.js'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  const DIC_MAP = {
    group: 'projectgrouptype',
    appName: 'recordmoduletype',
    level: 'riskleveltype'
  }
  export default {
    mixins: [dic, table, rac, exportTips],
    data () {
      return {
        siteList: {},
        select_record: {},
        select_risk: {},
        select_appName: {},
        selects: [],
        doExport: null,
        searchForm: {
          siteCode: '',
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: '',
          group: '',
          appName: '',
          level: ''
        },
        handleForm: {
          appName: '',
          group: '',
          opTime: '',
          duration: '',
          level: '',
          incidence: '',
          operator: '',
          remarks: '',
        },
        rules: {},
        tableControl: [
          {
            label: this.$t('common.edit'),
            callback: (row, index, data) => {
              this.operationDiaVis = true
              this.operationDiaTitle = this.$t('common.edit')
              this.selectId = row.id
              for (let i in this.handleForm) {
                this.handleForm[i] = row[i]
              }
              this.handleForm.opTime = TimeFormat.formatTimeTolong(this.handleForm.opTime)
              this.handleForm.group = Object.keys(this.select_record)
                .filter(item => this.select_record[item] === this.handleForm.group)[0]
              this.handleForm.appName = Object.keys(this.select_appName)
                .filter(item => this.select_appName[item] === this.handleForm.appName)[0]
              this.handleForm.level = Object.keys(this.select_risk)
                .filter(item => this.select_risk[item] === this.handleForm.level)[0]
            },
            rac: () => this.gRac('importantOperation@edit')
          }, {
            label: this.$t('common.delete'),
            callback: (row, index, data) => {
              this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
              }).then(() => {
                importantOperationBiz.delete({ id: row.id, siteCode: this.searchForm.siteCode }).then(() => {
                  this.successMessage()
                  this.searchTable()
                })
              }).catch(() => {})
            },
            rac: () => this.gRac('importantOperation@delete')
          }
        ],
        operationDiaTitle: '',
        operationDiaVis: false
      }
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetDictionaryByCode('recordmoduletype'),
          this.dGetDictionaryByCode('riskleveltype'),
          this.dGetDictionaryByCode('projectgrouptype')
        ])
        this.select_record = { ...this.dDictionary.projectgrouptype }
        this.select_risk = { ...this.dDictionary.riskleveltype }
        this.select_appName = { ...this.dDictionary.recordmoduletype }
        this.initTable()
        this.setRules()
      },
      getSiteList () {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.siteList = list
          this.searchForm.siteCode = Object.keys(this.siteList)[0]
          this.preInitTable()
          this.searchTable()
        })
      },
      initTable () {
        this.tInitTable({
          lanKey: 'importantOperation.table',
          head: ['group', 'appName', 'opTime', 'duration', 'level', 'incidence', 'operator', 'remarks'],
          requestFun: this.searchTable,
          headOpt: {
            group: {
              formatter: 'Dictionary',
              formatterDic: this.select_record
            },
            appName: {
              formatter: 'Dictionary',
              formatterDic: this.select_appName
            },
            level: {
              formatter: 'Dictionary',
              formatterDic: this.select_risk
            }
          }
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        if (!reqData.endTime) reqData.endTime = new Date().getTime()
        if (!reqData.level) reqData.level = 0
        importantOperationBiz.query(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.opTime = TimeFormat.getFormatTime(item.opTime).substr(0, 10)
            })
          }
          this.tData = data
        })
      },
      setRules () {
        for (let i in this.handleForm) {
          this.rules[i] = [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('importantOperation.' + i)}` }
          ]
        }
        delete this.rules.remarks
      },
      addOperation () {
        this.operationDiaTitle = this.$t('common.add')
        this.operationDiaVis = true
        for (let i in this.handleForm) {
          this.handleForm[i] = ''
        }
        this.$nextTick(() => {
          this.$refs['handleForm'].clearValidate()
        })
      },
      operationDiaConfirm () {
        this.$refs['handleForm'].validate((valid) => {
          if (valid) {
            let eventName = this.operationDiaTitle === this.$t('common.edit')
              ? 'update' : 'save'
            let saveObj = extend(true, {}, this.handleForm)
            saveObj.siteCode = this.searchForm.siteCode
            if (this.operationDiaTitle === this.$t('common.edit')) saveObj.id = this.selectId
            importantOperationBiz[eventName](saveObj).then(data => {
              this.operationDiaVis = false
              this.successMessage()
              this.searchTable()
            })
          } else {
            return false
          }
        })
      },
      multiSelect (val) {
        this.selects = val
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      },
      deleteOperation () {
        if (this.selects && this.selects.length > 0) {
          this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }).then(() => {
            let selected = []
            this.selects.map(item => {
              selected.push(item.id)
            })
            importantOperationBiz.deleteBatch({ ids: selected, siteCode: this.searchForm.siteCode }).then((data) => {
              this.successMessage()
              this.searchTable()
            })
          }).catch(() => {})
        } else {
          this.$message({
            message: this.$t('ALBTargetGroupManager.selectTips'),
            type: 'warning'
          })
        }
      },
      e_export () {
        const search = extend({}, this.searchForm)
        if (!search.endTime) search.endTime = new Date().getTime()
        if (!search.level) search.level = 0
        if (!this.doExport) this.doExport = this.exportOperation()
        this.doExport(search)
      },
      exportOperation () {
        const that = this
        const list = Object.assign({}, that.$t('importantOperation.table'))
        const dictionary = []
        for (const key in DIC_MAP) {
          dictionary.push({
            relate: key,
            type: that.dDictionary[DIC_MAP[key]]
          })
        }
        return function (search) {
          that.exRenderBefore()
          importantOperationBiz.export(
            list,
            search,
            ['opTime'],
            dictionary,
            that.exRenderTips,
            that.exRenderFail
          )
        }
      }
    },
    mounted () {
      this.getSiteList()
    }
  }
</script>

<style scoped>
</style>